module.exports = __webpack_public_path__ + "img/1970East-017_WEB-min.6a3ffad3.jpg";